###
  Native creative widget
###

class INTENT.utils.ImageUploader

  @ROOT_ATTR: "data-iu"

  @ATTR_URL: "#{@ROOT_ATTR}-url"
  @ATTR_SIZE: "#{@ROOT_ATTR}-size"
  @ATTR_IMAGE: "#{@ROOT_ATTR}-image"
  @ATTR_UPLOAD: "#{@ROOT_ATTR}-upload"

  constructor: (@root_image) ->
    @s = @.constructor

    @container_image = @root_image.find "[#{@s.ATTR_IMAGE}]"

    @field_size = @root_image.find "[#{@s.ATTR_SIZE}]"
    @field_image = @root_image.find "[#{@s.ATTR_URL}]"
    @btn_image = @root_image.find "[#{@s.ATTR_UPLOAD}]"

    @uploader = new qq.FileUploaderBasic({
      button: @btn_image[0],
      action: '/campaigns/upload_image',
      debug: true,
      inputName: 'image',
      encoding: 'multipart',
      multiple: false,
      onSubmit: @on_upload_submit,
      onUpload: @on_upload,
      onProgress: @on_upload_progress,
      onComplete: @on_upload_complete,
      onError: @on_upload_error
    })

  set_image: (http_file_url) =>
    # @container_image.attr 'href', http_file_url
    INTENT.utils.Forms.enable_submit_buttons()
    image = @container_image.find 'img'
    image.attr 'src', http_file_url
    image.on 'load', =>
      @container_image.fadeIn 'fast'
      image.fadeIn 'fast'

  on_upload_submit: =>
    @container_image.fadeIn 'fast'
    INTENT.utils.Forms.disable_submit_buttons()
    @container_image.find('img').hide()
    @container_image.find('.loader').show()

  on_upload: (id, fileName) =>
    # console.log id, fileName

  on_upload_progress: (id, fileName, loaded, total) =>
    percent = 0
    if loaded < total
      percent = Math.round(loaded / total * 100)

  on_upload_complete: (id, fileName, responseJSON) =>
    file_url = responseJSON.url
    http_file_url = 'https://' + file_url

    @field_size.attr 'value', responseJSON.size
    @container_image.fadeOut()
    @set_image http_file_url
    @field_image.attr 'value', file_url
    @field_image.change()
    @container_image.find('.loader').hide()

  on_upload_error: (id, name, reason, xhr) =>
    INTENT.utils.Forms.enable_submit_buttons()
    @container_image.find('.loader').hide()
    return false


class INTENT.widgets.NativeCreative

  @ATTR_NAME: "data-widget-native-creative"

  @ATTR_IMAGE_ROOT: "#{@ATTR_NAME}-image-root"

  constructor: (@el) ->
    @s = @.constructor
    @root_image = @el.find "[#{@s.ATTR_IMAGE_ROOT}]"

    @root_image.each ->
      new INTENT.utils.ImageUploader($(@))
